// ================================
// 🌍 Environment-Aware API Config
// ================================

const BUILD_ENV = "@@env"; // replaced by Gulp: "development" or "production"

const ENV_CONFIG = {
    local: {
        domain: "localhost",
        baseUrl: "https://devapi.example.in/api/v1",
    },
    dev: {
        domain: "devss.example.in",
        baseUrl: "https://devapi.example.in/api/v1",
    },
    stage: {
        domain: "stage.example.in",
        baseUrl: "https://stageapi.example.in/api/v1",
    },
    prod: {
        domain: "example.in",
        baseUrl: "https://api.example.in/api/v1",
    },
};

const origin = window.location.host || window.location.hostname;

let env = "local";
let BASE_URL = ENV_CONFIG.local.baseUrl;

if (origin.includes(ENV_CONFIG.dev.domain)) {
    env = "dev";
    BASE_URL = ENV_CONFIG.dev.baseUrl;
} else if (origin.includes(ENV_CONFIG.stage.domain)) {
    env = "stage";
    BASE_URL = ENV_CONFIG.stage.baseUrl;
} else if (origin.includes(ENV_CONFIG.prod.domain)) {
    env = "prod";
    BASE_URL = ENV_CONFIG.prod.baseUrl;
}

if (BUILD_ENV) {
    console.log("%c🌎 Build Environment:", "color: orange; font-weight: bold;", BUILD_ENV);
    console.log("%c🏠 Domain Environment:", "color: teal; font-weight: bold;", env);
    console.log("%c🔗 API Base URL:", "color: dodgerblue; font-weight: bold;", BASE_URL);
}

// ================================
// 🔗 Dynamic Portal Links
// ================================
const env_map = {
    local: "dev",
    dev: "dev",
    stage: "stage",
    prod: "login",
};

let MAIN_PORTAL_LINK;
let TABLE_PORTAL_LINK;
let B2C_WEB_LINK;
let B2C_PORTAL_LINK;

if (env === 'prod') {
    MAIN_PORTAL_LINK = `https://${env_map[env]}.example.in`;
    TABLE_PORTAL_LINK = `https://${env_map[env]}.example.in/open/tablelogin/login`;
} else {
    MAIN_PORTAL_LINK = `https://${env_map[env]}login.example.in`;
    TABLE_PORTAL_LINK = `https://${env_map[env]}login.example.in/open/tablelogin/login`;
}

if (env === 'prod') {
    B2C_WEB_LINK = `https://example.in/test`;
    B2C_PORTAL_LINK = `https://test.example.in`;
} else if (env === "stage") {
    B2C_PORTAL_LINK = `https://stagetest.example.in`;
}
else {
    B2C_PORTAL_LINK = `https://devtest.example.in`;
    B2C_WEB_LINK = `https://${env_map[env]}.example.in/test`;
}

// function to dynamically change portal links everywhere
let mainPortalLinks = document.querySelectorAll("[data-headerportallink='adminlogin']");
let tablePortalLinks = document.querySelectorAll("[data-headerportallink='tablelogin']");
let b2cPortalLinks = document.querySelectorAll("[data-headerportallink='b2clogin']");
let b2cWebLinks = document.querySelectorAll("[data-headerportallink='b2cweb']");

if (mainPortalLinks.length > 0) {
    mainPortalLinks.forEach(elem => {
        elem.addEventListener("click", (e) => {
            e.preventDefault();
            e.stopPropagation();
            window.open(MAIN_PORTAL_LINK, "_blank")
        });
    })
}

if (tablePortalLinks.length > 0) {
    tablePortalLinks.forEach(elem => {
        elem.addEventListener("click", (e) => {
            e.preventDefault();
            e.stopPropagation();
            window.open(TABLE_PORTAL_LINK, "_blank")
        });
    })
}

if (b2cPortalLinks.length > 0) {
    b2cPortalLinks.forEach(elem => {
        elem.addEventListener("click", (e) => {
            e.preventDefault();
            e.stopPropagation();
            window.open(B2C_PORTAL_LINK, "_blank")
        });
    })
}

if (b2cWebLinks.length > 0) {
    b2cWebLinks.forEach(elem => {
        elem.addEventListener("click", (e) => {
            e.preventDefault();
            e.stopPropagation();
            window.open(B2C_WEB_LINK, "_blank")
        });
    })
}

// ================================
// ⚡ Create Axios Instance
// ================================
const { axios } = window;
const api = axios.create({
    baseURL: BASE_URL,
    headers: {
        "Content-Type": "application/json",
    },
    timeout: 10000, // optional 10s timeout
});

// ================================
// 🔧 Interceptors
// ================================

// ✅ Request interceptor (optional for tokens, logging)
api.interceptors.request.use(
    (config) => {
        // Example: Add token if stored
        // const token = localStorage.getItem("access_token");
        // if (token) config.headers.Authorization = `Bearer ${token}`;

        if (BUILD_ENV === "development") {
            console.log("📤 Request:", config.method?.toUpperCase(), config.url, config.data || "");
        }
        return config;
    },
    (error) => Promise.reject(error)
);

// ✅ Response interceptor (logging + error handling)
api.interceptors.response.use(
    (response) => response.data,
    (error) => {
        console.log({ error });
        if (error.response) {
            console.error("❌ API Error:", error.response.status, error.response.data);

            Swal.fire({
                title: "Oops...",
                text: error.response.data.issues.error || error.response.data.issues.message || "Something went wrong!",
                icon: "error",
                showConfirmButton: true,
            });
        } else if (error.request) {
            console.error("⚠️ No response from server:", error.request);
        } else {
            console.error("🚨 Axios setup error:", error.message);
        }
        return Promise.reject(error);
    }
);

// ================================
// 📦 API Helper Functions
// ================================

export async function fetchGalleryPhoto() {
    try {
        const { data } = await api.get("gallery/photo/files", {
            params: { limit: "", order_by: "updatedAt", order_direction: "DESC" },
        });
        return data || [];
    } catch {
        return [];
    }
}

export async function fetchGalleryVideo() {
    try {
        const { data } = await api.get("gallery/video/", {
            params: { limit: "", order_by: "updatedAt", order_direction: "DESC" },
        });
        return data?.[0]?.records || [];
    } catch {
        return [];
    }
}

export async function fetchGalleryContent() {
    try {
        const { data } = await api.get("gallery/content/", {
            params: { limit: "", order_by: "updatedAt", order_direction: "DESC" },
        });
        return data?.[0]?.records || [];
    } catch {
        return [];
    }
}

export async function addLead(payload) {
    try {
        const { data } = await api.post("lead", payload);
        return data;
    } catch {
        return [];
    }
}

export async function addEnquire(payload) {
    try {
        const { data } = await api.post(`enquire/add/${payload?.email}`, payload);
        return data;
    } catch {
        return {};
    }
}

// ================================
// 🌍 Export Shared Globals
// ================================
export { api, BASE_URL, env, BUILD_ENV };
